import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ExpirationUnits } from '../filters/filter';
import {
  preventNonNumericalInput,
  stripLeadingZeros
} from '../earn-rules.utils';

@Component({
  selector: 'app-time-period',
  templateUrl: './time-period.component.html',
  styleUrls: ['./time-period.component.scss'],
  standalone: false
})
export class TimePeriodComponent implements OnInit {
  @Input() fg!: FormGroup;
  @Input() enableHour = false;
  @Input() enableYear = true;
  @Input() isViewOnly = false;
  @Input() expirationUnits: ExpirationUnits[] | undefined;
  selectedUnit!: ExpirationUnits;

  constructor() {}

  ngOnInit(): void {
    this.expirationUnits = Object.values(ExpirationUnits);
    if (!this.enableHour) {
      this.expirationUnits = this.expirationUnits.filter(
        (ob) => ob !== ExpirationUnits.HOUR
      );
    }
    if (!this.enableYear) {
      this.expirationUnits = this.expirationUnits.filter(
        (ob) => ob !== ExpirationUnits.YEAR
      );
    }
  }

  onUnitsChange() {
    this.fg.get('timePeriod')?.get('value')?.enable();
  }

  preventNonNumericalInput(e: KeyboardEvent) {
    preventNonNumericalInput(e);
  }

  onStripLeadingZeros(event: Event): void {
    stripLeadingZeros(event);
  }
}
